<template>
  <div class="installatorilist">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Gestisci Spostamento Installatori</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button :disabled="licenza.num_liberi <= 0" variant="success" style="float: right" to="/installatori/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Installatore</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span v-if="codiceConsulente">Codice Consulente: {{codiceConsulente}}  </span>
          <b-button size="sm" variant="success" v-on:click="generaCodiceConsulente()"><span v-if="!codiceConsulente">Genera un codice consulente </span><font-awesome-icon icon="redo" /></b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="tiporichiesta" slot-scope="row">
              {{(row.item.tiporichiesta) ? "Indipendente" : "Passaggio Consulente"}}
            </template>
            <template slot="action" slot-scope="row">
              <b-button v-if="row.item.tiporichiesta" size="sm" variant="danger" v-on:click="openModalDeleteTrasferimento(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button v-if="row.item.tiporichiesta" size="sm" style="margin-left: 10px;" variant="success" v-on:click="openModalAccettaTrasferimento(row.item)"><font-awesome-icon icon="check" /></b-button>


              <b-button v-if="!row.item.tiporichiesta" size="sm" variant="danger" v-on:click="openModalDeleteTrasferimento(row.item)"><font-awesome-icon icon="user-times" /></b-button>
              <b-button v-if="!row.item.tiporichiesta" size="sm" style="margin-left: 10px;" variant="success" v-on:click="openModalAccettaTrasferimento(row.item)" :disabled="!(licenza.num_liberi >= 0)"><font-awesome-icon icon="user-plus" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <br>
          <p style="color: grey" v-if="licenza.num_liberi >= 0">Licenza valida dal {{licenza.da}} al {{licenza.a}} per {{licenza.num_installatori}} installator{{licenza.num_installatori == 1 ? 'e' : 'i'}}. Puoi creare ancora {{licenza.num_liberi}} installator{{licenza.num_liberi == 1 ? 'e' : 'i'}}</p>
          <p style="color: grey" v-else>Non si possiede una licenza valida</p>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare la richiesta di trasferimento di <strong>"{{modalData.delete.denominazione}}"</strong> di tipo <strong>"{{(modalData.delete.tiporichiesta) ? "Indipendente" : "Passaggio Consulente"}}"</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteRichiestaTrasferimento(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.accetta" title="Vuoi proseguire?">
      <p>Sei sicuro di voler eseguire la richiesta di trasferimento di <strong>"{{modalData.accetta.denominazione}}"</strong> di tipo <strong>"{{(modalData.accetta.tiporichiesta) ? "Indipendente" : "Passaggio Consulente"}}"</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="accettaRichiestaTrasferimento(modalData.accetta.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.accetta = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'installatoriadd',
  data() {
    return {
      lista: [],
      codiceConsulente: "",
      campi: [
        {key: 'codice', label: 'Codice', sortable: true},
        {key: 'denominazione', label: 'Denominazione', sortable: true},
        {key: 'piva', label: 'P. IVA', sortable: true},
        {key: 'cf', label: 'Cod. Fiscale', sortable: true},
        {key: 'residenza', label: 'Residenza', sortable: true},
        {key: 'tiporichiesta', label: 'Tipo di richiesta', sortable: false},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false,
        accetta: false
      },
      modalData: {
        delete: {},
        accetta: {}
      },
      licenza: {}
    }
  },
  created: function(){
    this.getListaTrasferimenti()
  },
  methods: {
    getListaTrasferimenti(){
      Vue.http.post('installatore/manager/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.list
            this.totalRows = this.lista.length
            this.licenza = response.body.licenza
            this.codiceConsulente = response.body.codiceConsulente
        }else{
          this.lista = []
            /*Vue.notify({
                group: 'global',
                title: 'Errore',
                text: "Lista installatori non caricata correttamente.",
                type: 'error'
            })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    generaCodiceConsulente(){
      Vue.http.post('installatore/manager/genera', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaTrasferimenti()
          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Codice consulente generato con successo!",
              type: 'success'
          })
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    deleteRichiestaTrasferimento(idInstallatore){
      Vue.http.post('installatore/manager/rifiuta', {idInstallatore: idInstallatore}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaTrasferimenti()
          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Richiesta di trasferimento eliminata con successo!",
              type: 'success'
          })
          this.modal.delete = false
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    openModalDeleteTrasferimento(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    openModalAccettaTrasferimento(item){
      this.modalData.accetta = item
      this.modal.accetta = true
    },
    accettaRichiestaTrasferimento(idInstallatore){
      Vue.http.post('installatore/manager/accetta', {idInstallatore: idInstallatore}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaTrasferimenti()
          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Richiesta di trasferimento eseguita con successo!",
              type: 'success'
          })
          this.modal.accetta = false
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    }
  }
}
</script>


<style>
</style>